<template>
<div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        A NUDGE
        <small>View A Nudge Statistics</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">A Nudge Details</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div v-if="details.nudge" class="col-xs-12 col-lg-10 col-lg-offset-1">
                <p><strong>Category: </strong><span>{{ details.nudge.category }}</span></p>
                <p><strong>Message: </strong><span>{{ details.nudge.message.eng }}</span></p>
                <p><strong>From: </strong><span>{{ formatDate(details.nudge.dateFrom) }}</span></p>
                <p><strong>To: </strong><span>{{ formatDate(details.nudge.dateTo) }}</span></p>
                <p><strong>Requires Response: </strong><span>{{ details.nudge.requiresResponse }}</span></p>
                <p><strong>Description: </strong><span>{{ details.nudge.description }}</span></p>
                <br/>
                <h3>Statistics Response</h3>
                <table class="table table-striped">
                  <thead>
                    <th>Response</th>
                    <th>Count</th>
                  </thead>
                  <tbody>
                    <tr v-for="(each, index) in details.stats" :key="index">
                      <td>{{ each.response || 'No Response' }}</td>
                      <td>{{ each.number }}</td>
                    </tr>
                    <tr>
                      <td>Total</td>
                      <td>{{ total }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ANudgeStatistcs',
  methods: {
    formatDate (date) {
      if (!date) {
        return ''
      }
      const theDate = new Date(date)
      return `${theDate.getDate()}/${theDate.getMonth() + 1}/${theDate.getFullYear()}`
    },
    ...mapActions(['getANudgeDetails'])
  },
  computed: {
    total () {
      if (!this.details.stats.length) {
        return 0
      }
      return this.details.stats.reduce((prev, current) => prev + parseInt(current.number), 0)
    },
    ...mapState({
      details: state => state.nudge.aNudge
    })
  },
  mounted () {
    this.getANudgeDetails(parseInt(this.$route.query.nudge))
  }
}
</script>



// WEBPACK FOOTER //
// viewANudge.vue?3b4f3ab0